<template>
  <Card class="px-6 py-8 mt-8">
    <h3
      class="tracking-wide text-lg md:text-xl font-bold text-gray-900 md:text-3xl"
    >
      {{ session.title }} - {{ session.speakers[0].name }}
    </h3>
    <div class="max-w-lg lg:max-w-none lg:flex mt-2">
      <div class="  lg:flex-shrink-1 lg:w-2/3">
        <div class="mx-auto">
          <div class="mx-auto embed-container" v-if="replayReady">
            <iframe
              :src="session.youtubeEmbedURL"
              class="w-full"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <div v-if="false">
              <live-stream-player :session="session" />
            </div>
          </div>
          <img v-else :src="previewImage" />
        </div>

        <p class="mt-6 text-base leading-6 text-gray-500 prose">
          <standard-block-content
            :blocks="session.description"
          ></standard-block-content>
        </p>
        <div class="mt-8">
          <topic-grid :session="session" :color="topicColor"></topic-grid>
        </div>
        <div class="mt-10" v-if="hasTutorials">
          <tutorial-videos :session="session"></tutorial-videos>
        </div>
        <div class="mt-10">
          <session-compatibility-block
            :session="session"
          ></session-compatibility-block>
        </div>
        <div class="mt-10">
          <BarHeading>Comments &amp; Questions</BarHeading>
          <session-comment-area :session="session"> </session-comment-area>
        </div>
      </div>
      <div class="lg:w-1/3 px-4">
        <chat-box :session="session" :allow-chat="false"></chat-box>
      </div>
    </div>
  </Card>
</template>

<script>
import SessionCompatibilityBlock from "./SessionCompatibilityBlock";
import TopicGrid from "./TopicGrid";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import SessionCommentArea from "./SessionCommentArea";
import LiveStreamPlayer from "./LiveStreamPlayer";
import ChatBox from "./ChatBox";
import StandardBlockContent from "./StandardBlockContent";
import TutorialVideos from "./TutorialVideos";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import BarHeading from "./shared/BarHeading.vue";
import Card from "./shared/Card.vue";
import { colorFromSession } from "../utils/colorFromSession";

export default {
  name: "PreviousSessionPage",
  components: {
    Card,
    BarHeading,
    TutorialVideos,
    ChatBox,
    LiveStreamPlayer,
    SessionCompatibilityBlock,
    SessionCommentArea,
    TopicGrid,
    StandardBlockContent
  },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      liveChatSession: null,
      messages: [],
      id: null,
      messagesUnsubscribe: null,
      showChat: true,
      expandChat: true,
      scrollAtBottom: true,
      // This flag indicates a message is just in and we are waiting
      // before we update the scroll
      waiting: false,
      modal: false,
      toDelete: null
    };
  },
  computed: {
    replayReady() {
      return (
        this.session.youtubeEmbedURL && this.session.youtubeEmbedURL.length > 0
      );
    },
    hasTutorials() {
      const tutorials = this.session.tutorials || [];
      return tutorials.length > 0;
    },
    previewImage() {
      return sanityImageBuilder
        .image(this.session.previewImage)
        .width(400)
        .url();
    },
    topicColor() {
      return colorFromSession(this.session);
    }
  },
  methods: {
    handleScroll() {
      const el = this.$refs.messageChat.$el;
      const scrollTop = el.scrollTop;
      const clientHeight = el.clientHeight;
      const scrollHeight = el.scrollHeight;
      if (!this.waiting) {
        this.scrollAtBottom =
          Math.abs(scrollHeight - scrollTop - clientHeight) < 5;
      }
    },
    scrollToBottom() {
      console.info("From scrollToBottom function");
      this.$refs.messageChat.scrollToBottom();
    },
    handleScrollerVisible() {
      console.log("Scroller visible");
      console.log("Adding event listener");
      this.$refs.messageChat.$el.addEventListener("scroll", this.handleScroll);
    }
  }
};
</script>
<style scoped>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.scroller {
  height: 100%;
}

.wrapper-questions {
  height: 200px;
}
</style>
